import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import AlertBox from '../AlertBox';
import DSIcon from '../../../base/DSIcon';

import './EarlyExitNoticeWarningBox.scss';

const EarlyExitNoticeWarningBox = ({ className = null }) => {
  const componentClassName = classNames('early-notice-warning', className);

  return (
    <AlertBox
      className={componentClassName}
      icon={<DSIcon name="check_circle" />}
      iconPosition="top"
      title={trans('listing.early-checkout.notice.title')}
      message={
        <p className="early-notice-warning__content">
          {trans('listing.early-checkout.notice.message')}
        </p>
      }
      roundedCorners
    />
  );
};

EarlyExitNoticeWarningBox.propTypes = {
  className: PropTypes.string
};

export default EarlyExitNoticeWarningBox;
